var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1409_4439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.9347 0 0 4.9347 0 11C0 17.0653 4.9347 22 11 22C17.0653 22 22 17.0653 22 11C22 4.9347 17.0653 0 11 0ZM2.75 11C2.75 9.221 3.32169 7.57618 4.28295 6.22728L15.7727 17.7171C14.4238 18.6783 12.779 19.25 11 19.25C6.45069 19.25 2.75 15.5493 2.75 11ZM17.717 15.7727L6.22724 4.28295C7.57614 3.32169 9.22096 2.75 11 2.75C15.5493 2.75 19.25 6.45069 19.25 11C19.25 12.779 18.6783 14.4238 17.717 15.7727Z",
    fill: "#93B4CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1409_4439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock1);
export default __webpack_public_path__ + "static/media/block 1.9c2fdfe11cde62ac39cb02ff9fe4056a.svg";
export { ForwardRef as ReactComponent };